var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.utils.css_browser_selector(_vm.navigator.userAgent),attrs:{"id":"app"}},[_c('div',{attrs:{"id":"App-main"}},[_c('router-view')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }